/**
 * NG Animate has a compatibility issue with angular ui carousel. We just disable aniations on carousel for now.
 */
angular.module("app").directive("disableNgAnimate", ["$animate", function ($animate) {
	return {
		restrict: "A",
		link: function (scope, element) {
			$animate.enabled(false, element);
		}
	};
}]);
